import { ChainTokenCheckResult } from './chain-token-check-result';
import { BaseEntityModel } from './base-entity-model';
import { ChainTokenTradeableCategory } from '../enum';

export class ChainTokenCheck implements BaseEntityModel {
  id: string | undefined;
  creationDate: Date;
  modificationDate: Date;
  results: ChainTokenCheckResult[];

  public isTradeable(): boolean {
    return !!this.results.find(result => result?.isTradeable());
  }

  public getTradeableCategory(): ChainTokenTradeableCategory {
    if (!this.isTradeable()) {
      return ChainTokenTradeableCategory.NOT_TRADEABLE;
    }

    const hasGoodLiquidity = this.results.find(
      result =>
        result.getTradeableCategory() === ChainTokenTradeableCategory.TRADEABLE,
    );

    const hasBadLiquidity = this.results.find(
      result =>
        result.getTradeableCategory() ===
        ChainTokenTradeableCategory.BAD_LIQUIDITY,
    );

    if (hasGoodLiquidity && hasBadLiquidity) {
      return ChainTokenTradeableCategory.MIXED_LIQUIDITY;
    }
    if (hasGoodLiquidity) {
      return ChainTokenTradeableCategory.TRADEABLE;
    } else {
      return ChainTokenTradeableCategory.BAD_LIQUIDITY;
    }
  }

  public getSortedResults(): ChainTokenCheckResult[] {
    return this.results.sort(
      (a: ChainTokenCheckResult, b: ChainTokenCheckResult) => {
        if (!a.isLiquiditySourceEnabled && b.isLiquiditySourceEnabled) {
          return 1;
        }
        if (!b.isLiquiditySourceEnabled && a.isLiquiditySourceEnabled) {
          return -1;
        }

        if (!a.trade && b.trade) {
          return 1;
        }
        if (!b.trade && a.trade) {
          return -1;
        }

        const sourceCompare = a.liquiditySource.identifier.localeCompare(
          b.liquiditySource.identifier,
        );
        if (sourceCompare || (!a.trade && !b.trade)) {
          return sourceCompare;
        }

        return a.trade.fromValueInUsd - b.trade.fromValueInUsd;
      },
    );
  }

  public toString(): string {
    let resultString = '';
    this.getSortedResults().forEach(result => {
      resultString += `\n\n${result.toString()}`;
    });

    return `${resultString}`;
  }
}
